<template>
  <div class="main">
    <el-button size="small" class="record-btn" icon="el-icon-document" @click="showRecord">
      批量下单记录
    </el-button>
    <div>
      <el-steps :active="step" align-center>
        <el-step title="下载模板并上传文件" description="" />
        <el-step title="下单导入处理" description="" />
        <el-step title="完成下单" description="" />
      </el-steps>
    </div>

    <div v-show="step==0" class="upload-container">
      <el-upload
        class="upload-demo"
        :action="'/api/file/uploader/temporaryFile' | toUrl()"
        :headers="{ Authorization: token}"
        :limit="1"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :file-list="fileList"
        accept=".xls,.xlsx"
      >
        <img src="../../assets/img/manage/upload.png" style="width: 61px;height: 78x;">
      </el-upload>
      <p class="upload-title">
        点击上传填写好的订单表
      </p>
      <p class="tip">
        文件后缀名仅支持 xls 或 xlsx，<br>
        大小不超过 50MB，最多支持导入 1000 条数据
      </p>
      <el-button size="small" icon="el-icon-download" class="download-btn" @click="templateDownload">
        FBA 批量下单模板下载
      </el-button>
    </div>
    <div v-show="step==1" class="upload-container">
      <img src="../../assets/img/manage/loading.gif" style="width: 61px;height: 78x;">
      <div class="success-box">
        <img src="../../assets/img/manage/success.png" style="width: 70px;height: 70x;">
        <span class="success-tip">订单上传成功，正在处理中</span>
      </div>
      <p class="tip">
        下单数据处理需要一定时间，您可稍后回来在右上角 “<span class="link">批量下单记录</span>” 中查看下单结果
      </p>
    </div>
    <div v-show="step==2" class="result-container">
      <div class="file-table">
        <table class="table">
          <tr>
            <td>上传文件名</td>
            <td>总订单数</td>
            <td>上传成功订单数</td>
            <td>上传失败订单数</td>
            <td>导出上传失败订单</td>
          </tr>
          <tr>
            <td>{{ result.fileName }}</td>
            <td>{{ result.fnum+result.snum }}</td>
            <td>
              {{ result.snum }}
            </td>
            <td>
              {{ result.fnum }}
              <span v-if="result.fnum>0" style="color:#3370FF;cursor: pointer;" @click="()=>{ isShowFailResult = true}">查看</span>
            </td>
            <td style="color: #3370FF;cursor: pointer;;" @click="exportResult(result)">
              导出
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-show="step==3" class="result-container">
      <div class="file-table">
        <table class="table">
          <tr>
            <td>文件上传失败</td>
          </tr>
          <tr>
            <td>{{ failReason }}</td>
          </tr>
        </table>
      </div>
    </div>
    <RecordDialog :value="isShowRecord" @close="()=>{ isShowRecord = false}">
      <template v-slot:title>
        <div>批量下单记录</div>
      </template>
      <template v-slot:body>
        <div class="record-title">近一个月的下单记录</div>
        <div class="file-table">
          <table class="table">
            <thead>
              <tr>
                <td>上传文件名</td>
                <td>操作人</td>
                <td>导入（总计/成功/失败）</td>
                <td>状态</td>
                <td>上传时间</td>
                <td>操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in recordList" :key="index" style="">

                <td>{{ item.fileName }}</td>
                <td>{{ item.creatorName }}</td>
                <td>{{ item.totalNum }} / <span class="green">{{ item.successNum }}</span> / <span class="red">{{ item.failNum }}</span></td>
                <td>
                  <span v-if="item.status==1" class="green">成功</span>
                  <span v-if="item.status!=1" class="red">失败</span>
                </td>
                <td>{{ xms.toDate(item.creatorTime) }}
                </td>
                <td style="color: #3370FF;cursor: pointer;;" @click="exportResult(item)">
                  导出
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </template>
      <template v-slot:footer />
    </RecordDialog>
    <RecordDialog :value="isShowFailResult" @close="()=>{ isShowFailResult = false}">
      <template v-slot:title>
        <div>查看失败原因</div>
      </template>
      <template v-slot:body>
        <div class="record-title">导入失败，请按提示修改后重新导入。</div>
        <div class="file-table">
          <table class="table">
            <thead style="width: 100%;">
              <tr>
                <td>错误位置</td>
                <td>错误原因</td>
              </tr>
            </thead>
            <tbody style="width: 100%;">
              <tr v-for="(item,index) in result.failResult" :key="index" style="width: 100%;">

                <td>{{ item.failName }}</td>
                <td>{{ item.reason }}</td>
              </tr>
            </tbody>

          </table>
        </div>
      </template>
      <template v-slot:footer />
    </RecordDialog>
  </div>
</template>

<script>
import {
  getCookie
} from '@/utils/cookiejs'
import RecordDialog from '@/components/Dialog/Dialog.vue'
import request from '@/utils/request'
export default {
  components: {
    // 组件的引用
    RecordDialog
  },
  data() {
    return {
      fileList: [],
      step: 0,
      token: '',
      fileName: '',
      list: [],
      result: {},
      isShowRecord: false,
	  isShowFailResult: false,
      recordList: [],
	  isImportFailed: false,
	  failReason: ''
    }
  },
  created() {
    this.token = getCookie('token')
  },
  methods: {
    showRecord() {
      this.isShowRecord = true
      request({
        url: `/api/webapi/order/GetImportRecords`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.recordList = res.data
      })
    },
    beforeUpload(file) {
      if (file.size > 50 * 1024 * 1024) { // 10MB 大小验证
        this.$message.error('文件大小不能超过 50MB')
        return false
      }
      return true // 可在此处添加实际上传逻辑（如调用接口）
    },
    handleSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.fileName = res.data.name
        this.step++
        request({
          url: `/api/shipping/fbaOrder/importPreview`,
          method: 'GET',
          data: {
            fileName: this.fileName
          },
          headers: {
            Authorization: this.token
          }
        }).then((res) => {
          this.list = res.data.dataRow
          this.list.forEach(item => {
            item.fileName = file.name
          })
          request({
            url: `/api/shipping/fbaOrder/importData`,
            method: 'POST',
            data: this.list,
            headers: {
              Authorization: this.token
            }
          }).then((res) => {
			  if (res.code == 200) {
				  this.result = res.data
				  this.result.fileName = file.name
				  this.step++
			  }
          }).catch((res) => {
			  this.step = 3
			  this.failReason = res
		  })
        })
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1000
        })
      }
    },
    exportResult(item) {
      request({
        url: `/api/webapi/order/ExportImportDetails`,
        method: 'GET',
        data: {
          importNo: item.importNo
        },
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.xms.downloadFile(res.data.url)
      })
    },
    templateDownload() {
      request({
        url: `/api/shipping/fbaOrder/CustomerTemplateDownload`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.xms.downloadFile(res.data.url)
      })
    }
  }
}
</script>

<style scoped lang="scss">
	.main {
		padding-top: 40px;
		background-color: #ffffff;
		padding-bottom: 80px;
	}

	.upload-container {
		text-align: center;
		padding: 50px 0;
		width: 60%;
		margin-top: 50px;
		margin-left: 20%;
		border: 2px dashed #EBEBED;
		border-radius: 20px;
		background-color: #F8FBFC;
		height: 280px;
	}

	.result-container {
		text-align: center;
		padding: 50px 0;
	}

	.upload-title {
		color: #172031;
		font-size: 16px;
		font-weight: 800;
	}

	.tip {
		color: #808597;
		font-size: 14px;
	}

	.download-btn {
		background: #F8FBFC;
		border-radius: 34px 34px 34px 34px;
		border: NaNpx solid #DFE9FF;
		color: #1172FC;
		padding: 15px;
		border-color: #1172FC;
		margin-top: 30px;
	}

	.record-btn {
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: NaNpx solid #3370FF;
		color: #1172FC;
		border-color: #1172FC;
		margin-left: 85%;
	}

	.success-box {
		display: flex;
		align-items: center;
		height: 70px;
		justify-content: center
	}

	.link {
		color: #3370FF;
	}

	.success-tip {
		color: #272727;
		font-size: 18px;
		margin-left: 5px;
	}

	.file-table {
		text-align: center;

		.table {
			border: 1px solid rgba(221, 221, 221, 0.56);
			border-radius: 8px;
			width: 90%;
			border-collapse: collapse;
			margin-left: 5%;
			padding: 0 8px;

			thead:nth-of-type(1) {
				td {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #777777;
					background: rgba(221, 221, 221, 0.24);
					width: 200px;
				}
			}

			tr {
				height: 40px;

				td {
					padding-left: 8px;
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
					width: 200px;

					.division-line {
						display: inline-block;
						height: 20px;
						width: 100%;
						border-right: 1px solid #DDDDDD;
					}

					.blue {
						color: #027FFC;
						cursor: pointer;
					}
				}
			}
		}
	}

	::v-deep .dialog {
		width: 1132px;
		height: 600px;

		.dialog__header {
			text-align: left;
		}

		.dialog__body {
			padding: 0px;
		}

		.el-form-item--medium {
			width: 47%;
			margin-bottom: 0px
		}

		.commodities {
			height: auto;

			.main-info {
				padding: 0px;
			}
		}
	}

	.record-title {
		text-align: left;
		padding: 10px;
		font-size: 14px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.red{
		color: #FF5E5E;
	}
	.green{
		color: #13ce66;
	}

	table tbody {
	    display: block;
	    height: 395px;
	    overflow-y: scroll;
	}

	table thead,
	tbody tr {
	    display: table;
	    table-layout: fixed;/*重要  表格固定算法*/
	}
</style>
